import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ConstantsService } from '../../fidelidade/ConstantsService';
import { RotaGuardClient } from '../../guards/auth-loja.guard';
import { AutorizacaoService } from '../../services/autorizacao.service';
import {
  DescobertaRecursosService,
  InteresseRecurso,
  OrigemInteresseRecurso,
  RecursoCliente
} from '../../services/descoberta-recursos.service';

@Component({
  selector: 'app-chamada-recurso-contextual',
  templateUrl: './chamada-recurso-contextual.component.html',
  styleUrls: ['./chamada-recurso-contextual.component.scss']
})
export class ChamadaRecursoContextualComponent implements OnInit, OnDestroy {
  @Input() slug: string;
  @Input() origem: OrigemInteresseRecurso;
  @Input() titulo: string;
  @Input() descricao: string;
  @Input() icone = 'fa-compass';

  recurso: RecursoCliente | null = null;
  interesseAberto: InteresseRecurso | null = null;

  private readonly destroy$ = new Subject<void>();
  private sequenciaConsulta = 0;
  private empresaId: number | null = null;

  constructor(
    private descobertaRecursosService: DescobertaRecursosService,
    private constantsService: ConstantsService,
    private autorizacaoService: AutorizacaoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const usuario = this.autorizacaoService.getUser();
    if (!RotaGuardClient.gerenciaLoja(usuario)) return;

    this.constantsService.empresa$
      .pipe(takeUntil(this.destroy$))
      .subscribe(empresa => this.carregueParaEmpresa(empresa));
  }

  ngOnDestroy(): void {
    this.sequenciaConsulta++;
    this.destroy$.next();
    this.destroy$.complete();
  }

  abraDetalhes(): void {
    if (!this.recurso) return;

    this.router.navigate(['/admin/explorar-recursos'], {
      queryParams: { recurso: this.slug, origem: this.origem }
    });
  }

  private async carregueParaEmpresa(empresa: any): Promise<void> {
    const sequencia = ++this.sequenciaConsulta;
    this.empresaId = empresa?.id || null;
    this.recurso = null;
    this.interesseAberto = null;
    if (!this.empresaId || !this.slug) return;

    try {
      const catalogo = await this.descobertaRecursosService.obtenhaCatalogo();
      if (sequencia !== this.sequenciaConsulta || empresa?.id !== this.empresaId) return;

      const recurso = (catalogo.recursos || []).find(item => item.slug === this.slug);
      if (!recurso || recurso.status !== 'DISPONIVEL') return;

      this.recurso = recurso;
      this.interesseAberto = (catalogo.interesses || []).find(interesse =>
        interesse.recurso.slug === this.slug && interesse.status !== 'CONCLUIDO'
      ) || null;
    } catch (_) {
      if (sequencia === this.sequenciaConsulta) {
        this.recurso = null;
        this.interesseAberto = null;
      }
    }
  }
}
